import HTTPClient from '@elab/core/utils/HTTPClient';
import apiUtils from '@elab/core/utils/apiUtils';

const getApiService = () => `${apiUtils.getBaseUri()}/users`;

const getCustomerAddress = async userId => {
    const uri = `${getApiService()}/${userId || 'anonymous'}/addresses`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(`Unable to load address (${response.status})`);
    }
    return await response.json();
};

const getCustomerBillingAddress = async userId => {
    const uri = `${getApiService()}/${userId || 'anonymous'}/addresses/billing`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(`Unable to load address (${response.status})`);
    }
    return await response.json();
};

export default {
    getCustomerAddress,
    getCustomerBillingAddress,
};
